/*
 * @Author: 
 * @Date: 2024-02-20 10:37:39
 * @LastEditors: lwk
 * @LastEditTime: 2024-02-22 15:52:03
 * @Description: 请填写简介
 */

import request from "@/utils/request";

// 获取得分统计下拉列表
export function getScore() {
  return request({
    url: "/pt/morning-conference/scoreStatisticsSpinner",
    method: "get",
  })
}

// 获取分项统计部门列表
export function getSubentry() {
  return request({
    url: "/pt/morning-conference/subentryStatisticsSpinner",
    method: "get",
  })
}

// 获取得分统计数据
export function getScoreData(params) {
  return request({
    url: "/pt/morning-conference/scoreStatisticsShow",
    method: "get",
    params
  })
}
// 获取得分统计数据
export function getSubentryData(params) {
  return request({
    url: "/pt/morning-conference/subentryStatisticsShow",
    method: "get",
    params
  })
}
// 获取数据统计数据
export function getDataPage(params) {
  return request({
    url: "/pt/morning-conference/dataStatisticsPage",
    method: "get",
    params
  })
}
// 获取数据统计数据详情
export function getDataPageDetail(params) {
  return request({
    url: "/pt/morning-conference/getDataStatisticsBySerialNum",
    method: "get",
    params
  })
}
// 获取在线评价数据列表
export function getOnlinePage(params) {
  return request({
    url: "/pt/morning-conference/onLineEvaluatePage",
    method: "get",
    params
  })
}
// 获取在线评价数据详情
export function getOnlinePageDetail(params) {
  return request({
    url: "/pt/morning-conference/getEvaluateBySerialNum",
    method: "get",
    params
  })
}
// 获取在线评价数据详情
export function proceedEvaluate(params) {
  return request({
    url: "/pt/morning-conference/proceedEvaluate",
    method: "post",
    data:params
  })
}
// 导出数据统计
export function dataStatisticsExport(params) {
  return request({
    url: "/pt/morning-conference/dataStatisticsExport",
    method: "get",
    params,
    responseType: 'blob'
  })
}

// 查询关键工作完成率统计
export function getaccomplishRate(params) {
  return request({
    url: "/pt/morning-conference/accomplishRateStatistics",
    method: "get",
    params
  })
}
// 查询关键工作完成率明细
export function getAccomplishDetail(params) {
  return request({
    url: "/pt/morning-conference/accomplishDetail",
    method: "get",
    params
  })
}


// 获取月份日期
export function getShowDate(params) {
  return request({
    url: "/pt/morning-conference/getShowDate",
    method: "get",
    params
  })
}
// 导入
export function importExcel(params) {
  return request({
    url: "/pt/morning-conference/import",
    method: "post",
    data: params
  })
}

// 获取动态表头
export function accomplishDetailHeader(params) {
  return request({
    url: "/pt/morning-conference/accomplishDetailHeader",
    method: "get",
    params
  })
}

// 导出关键工作
export function exportWork(params) {
  return request({
    url: "/pt/morning-conference/export",
    method: "get",
    params,
    responseType: 'blob'
  })
}


// WEBPACK FOOTER //
// ./src/api/morningMeet.js